import { User } from "../interfaces/user.interface";
import { Message } from "./message.model";

export interface Chat {
    owner: User;
    recipient?: User;
    history: Array<Message>;
}


export enum ChatRole {
  User = 0,
  Assistant = 1,
  DataStorage = 2,
}

export interface ChatMessage {
  message: string;
  role: ChatRole;
  timestamp: string;
  displayedMessage?: string;  // or Date, depending on how you handle dates
}

export interface ChatHistory {
  messages: ChatMessage[];
}

export interface RequestToAssistant {
  chatHistory: ChatHistory;
  bomModelsIds: string[];
}
